<div id="deniedWrapper" class="denied-wrapper">
  <div id="deniedText" class="denied-text">{{appStrings.accessDenied}}</div>
  <br/>
  <a [routerLink]="['/']" id="deniedAction" class="denied-action" [hidden]="noAccess">{{appStrings.notFoundGoHome}}</a>
</div>